/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Session from '@linc-technologies/linced-common/models/bookings/session';

// Proto: bookings.Date.
export default class Date extends Fragment {
  declare [Type]: 'bookings/date';

  // date is a string representation of the event date
  @attr('string')
  declare date: string | undefined;

  // sessions contains one or more sessions for the date.
  @fragmentArray('bookings/session')
  declare sessions: FragmentArray<Session>;

  @alias('sessions.length')
  declare sessionCount: number;

  @computed('sessions.@each.{startTime,endTime}')
  get flattenedSessions() {
    return this.sessions
      .reduce((times: (number | undefined)[], session) => {
        times.push(session.startTime);
        times.push(session.endTime);
        return times;
      }, [])
      .join();
  }
}
